module.exports = __webpack_public_path__ + "assets/newsletter-arrow-down.a078377d.svg";